<template>
  <div>
    <BaseDialog :is-open="isDialogOpen" v-if="isDialogOpen">
      <template v-slot:title>
        Restore Organisation Unit
      </template>
      <template v-slot:body>
        <v-form ref="form" lazy-validation class="mr-5">
          <Select
            :disabled="isLoading"
            label="Parent Organisation Unit"
            @change="parentId = $event"
            :value="parentId"
            placeholder="Select Organisation Unit"
            :items="units"
            item-text="name"
            item-value="id"
            autocomplete
            :rules="isRequired('Parent Organisation Unit', shouldValidate)"
            :loading="isFetchingParentUnits"
          />
        </v-form>
      </template>
      <template v-slot:actions>
        <PrimaryButton text @click="close">Cancel</PrimaryButton>
        <PrimaryButton @click="handleSave" :loading="isLoading">
          Save Changes
        </PrimaryButton>
      </template>
    </BaseDialog>
  </div>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { ORGANISATION_UNITS_NAMESPACE } from "@/store/modules/organisations/organisation-units";
import { createNamespacedHelpers } from "vuex";
import { isRequired } from "@/utils/validation/rules";
import Select from "@/components/common/Select";
import {
  RESTORE_ORGANISATION_UNIT,
  FETCH_PARENT_UNITS
} from "@/store/modules/organisations/organisation-units/actions";
import { copyState } from "@/utils/helpers";
import { filter, isEmpty } from "lodash";

const { mapActions, mapState } = createNamespacedHelpers(
  ORGANISATION_UNITS_NAMESPACE
);
export default {
  components: { Select, PrimaryButton, BaseDialog },
  props: {
    unit: {
      type: Object,
      required: true
    },
    isOpen: Boolean
  },
  created() {
    if (isEmpty(this.parentUnits)) {
      this.fetchOrgUnits();
    }
  },
  data() {
    return {
      isDialogOpen: this.isOpen,
      isLoading: false,
      shouldValidate: false,
      parentId: this.unit && this.unit.parentId
    };
  },
  computed: {
    ...mapState(copyState(["parentUnits", "isFetchingParentUnits"])),
    units() {
      return filter(this.parentUnits, unit => {
        if (this.unit.parentId) {
          return unit.id !== this.unit.id;
        }
        return unit;
      });
    }
  },
  methods: {
    ...mapActions({
      restoreOrganisationUnit: RESTORE_ORGANISATION_UNIT,
      fetchOrgUnits: FETCH_PARENT_UNITS
    }),
    isRequired,
    close() {
      this.$emit("close");
    },
    async handleSave() {
      this.shouldValidate = true;
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.isLoading = true;
        await this.restoreOrganisationUnit({
          parentId: this.parentId,
          id: this.unit.id
        });
        this.close();
        this.$emit("update");
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped></style>
